export default "__VITE_ASSET__BezURNIp__"